import { atom } from 'jotai';

const version = atom({
    key: 'versionState',
    default: ''
});

export default version;
